import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';

import css from '../css-snippets/section-orthopedic-card-basic.js';

const IMAGE_1 = 'https://cdn.skyfastimg.com/images/2026/06/23/image-6a3a5dc2db5b59c98c46a627.png?w=500&h=50&q=80';
const IMAGE_2 = 'https://cdn.skyfastimg.com/images/2026/06/23/image-6a3a5dd0b7a0975d92d8c168.png?w=500&h=50&q=80';
const IMAGE_3 = 'https://cdn.skyfastimg.com/images/2026/06/23/image-6a3a5ddd8364ce9e4c91c834.png?w=500&h=50&q=80';
const SIGNATURE_IMAGE =
  'https://cdn.skyfastimg.com/images/2026/06/23/image-6a3a51efbdd4e131eca10a8a.png?w=200&h=50&q=80';

const buttonHtml = buttonPrimary({
  text: 'Purchase Now',
  backgroundColor: '#006196',
  radius: 12,
  iconPrefix: { show: false, src: '' },
  iconSuffix: { show: false, src: '' },
  subBtn: { show: false, text: '' },
});

const contentHtml = `
  <div
    class="orthopedic-card-basic container"
    data-attribute="orthopedic-card-basic-content"
    data-image-position="left"
    data-gap="80"
    style="--section-gap: 80px;"
  >
    <div class="orthopedic-card-basic__images" data-attribute="orthopedic-card-basic__images">
      <div class="orthopedic-card-basic__image-item" data-attribute="orthopedic-card-basic__image-1">
        <img
          data-attribute="orthopedic-card-basic__image-img-1"
          src="${IMAGE_1}"
          alt=""
        />
      </div>
      <div class="orthopedic-card-basic__image-item" data-attribute="orthopedic-card-basic__image-3">
        <img
          data-attribute="orthopedic-card-basic__image-img-3"
          src="${IMAGE_3}"
          alt=""
        />
      </div>
      <div class="orthopedic-card-basic__image-item" data-attribute="orthopedic-card-basic__image-2">
        <img
          data-attribute="orthopedic-card-basic__image-img-2"
          src="${IMAGE_2}"
          alt=""
        />
      </div>
    </div>
    <div class="orthopedic-card-basic__content" data-attribute="orthopedic-card-basic__content">
      <div
        class="orthopedic-card-basic__text"
        data-attribute="orthopedic-card-basic__text"
      >
        <h2>
          <span style="color: hsl(201, 100%, 29%); font-size: 52px"
            ><strong>CLINICALLY INFORMED! <br> PATIENT APPROVED!</strong></span
          >
        </h2>
        <p>
          <span style="color: hsl(228, 3%, 34%); font-size: 20px"
            >Every feature of the CONVEN Knit Slip-On is
            <strong>backed by orthopedic principles</strong>. We studied the gait
            cycles of <strong>over 1,000 individuals</strong> suffering from chronic
            foot conditions. The result?&nbsp;</span
          >
        </p>
        <p>
          <span style="color: hsl(228, 3%, 34%); font-size: 20px"
            >A shoe that mirrors the natural shape of the foot while providing the
            mechanical assistance during long-duration standing or walking.</span
          >
        </p>
        <p>
          <span style="color: hsl(228, 3%, 34%); font-size: 20px"
            ><strong
              >Most commercial shoes are designed for mass-market aesthetics</strong
            >, not medical support.&nbsp;</span
          >
        </p>
        <p>
          <span style="color: hsl(228, 3%, 34%); font-size: 20px"
            >They use <strong>cheap EVA foam</strong> that loses its "bounce" in
            weeks, leaving you standing on a flat, hard surface.&nbsp;</span
          >
        </p>
        <p>
          <span style="color: hsl(228, 3%, 34%); font-size: 20px"
            >Even expensive "runners" often have a narrow "V-shape" that crushes your
            toes together, worsening bunions and nerve pain.&nbsp;</span
          >
        </p>
        <p>
          <span style="color: hsl(228, 3%, 34%); font-size: 20px"
            ><strong>CONVEN is built for longevity</strong>, not just the first
            week!</span
          >
        </p>
      </div>

      <div
        class="orthopedic-card-basic__signature"
        data-attribute="orthopedic-card-basic__signature"
        data-show="false"
      >
        <img
          data-attribute="orthopedic-card-basic__signature-img"
          src="${SIGNATURE_IMAGE}"
          alt=""
        />
      </div>
      ${buttonHtml}
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  topPadding: true,
  bottomPadding: true,
});
